import React, { Component } from "react";
// eslint-disable-next-line no-unused-vars
import Axios from "axios";
//running list of things we should see on the dashboard.

//Bank time!
//Tasks due today (and maybe overdue tasks)
//Todays 'expected hours'
//Some 'productivity' stats. Maybe tasks complete in the last week?

export class Dashboard extends Component {
  componentDidMount() {}
  render() {
    return (
      <main className="content">
        <div className="container-fluid"></div>
      </main>
    );
  }
}

export default Dashboard;
